import React from "react";
import Container from "reactstrap/lib/Container";
import withStyles from "react-jss";
import { webpSimpleTransformer } from "Helpers/ImageManager";
import { BackgroundImage } from "ComponentsUI/BackgroundImage";

const styles = (theme) => ({
	root: {
		padding: "90px 0",
		position: "relative",
	},
	header: {
		fontFamily: theme.fonts.bold,
		fontSize: "48px",
		lineHeight: 1,
		color: theme.palette.colors.white,
		marginBottom: "54px",
		textAlign: "center",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		header: {
			marginBottom: "34px",
			fontSize: "36px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			padding: "36px 0",
		},
		header: {
			marginBottom: "40px",
			fontSize: "24px",
		},
	},
});

class FormBackground extends React.Component {
	render() {
		let classes = this.props.classes;

		if (!this.props.children) {
			return null;
		}

		return (
			<div className={classes.root}>
				<BackgroundImage
					webpTransformer={webpSimpleTransformer}
					background={this.props.images}
					windowSizes={this.props.windowSizes}
				/>
				<Container>
					<div className={classes.header}>{this.props.header}</div>
					<div className={classes.form}>{this.props.children}</div>
				</Container>
			</div>
		);
	}
}

export default withStyles(styles)(FormBackground);
